/* eslint-disable */
import { useState } from 'react';
import QualityAnalysisDashboard from '@/Components/NewQualityAnalysis/NewQualityAnalysis';
import { Tabs, Nav } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';

function NewQualityAnalysisPage() {
  const [activeTab, setActiveTab] = useState('sourcing');
  
  const tabs = [
    {
      label: 'Sourcing',
      value: 'sourcing',
    },
    {
      label: 'Production',
      value: 'production',
    },
    {
      label: 'Distribution',
      value: 'distribution',
    },
  ];

  const handleTabChange = (value) => {
    setActiveTab(value);
  };

  return (
    <div>
        <div className='bg-gray-100 w-full'>
        <div className='flex'>
          {tabs.map((tab) => (
            <div
              key={tab.value}
              className={`p-3 cursor-pointer flex items-center justify-center ${
                activeTab === tab.value 
                  ? 'bg-white border-t border-l border-r rounded-t-lg min-w-[200px] text-center text-black font-bold' 
                  : tab.value === 'distribution' 
                    ? 'text-slate-400 font-bold min-w-[200px] text-center pointer-events-none'
                    : 'text-slate-700 font-bold min-w-[200px] text-center'
              }`}
              onClick={() => handleTabChange(tab.value)}
            >
              {tab.value === 'distribution' ? (
                <div className='flex items-center'>
                  {tab.label} <span className='bg-slate-400 rounded-full px-2 py-1 ml-2 text-xs font-bold text-slate-600'>Coming Soon</span>
                </div>
              ) : tab.label}
            </div>
          ))}
        </div>
      </div>
      <div className='container mx-auto py-4'>
        {activeTab === 'sourcing' && (
          <QualityAnalysisDashboard
            activeMainTab={activeTab}
          />
        )}
        {activeTab === 'production' && (
            <QualityAnalysisDashboard
              activeMainTab={activeTab}
            />
        )}
        {activeTab === 'distribution' && (
            <QualityAnalysisDashboard
              activeMainTab={activeTab}
            />
        )}
      </div>
    </div>
  );
}

export default NewQualityAnalysisPage;

